import { exportGridToExcel } from "../../utils/devextreme_utils";

/**
 * @typedef {Object} ExportPluginOptions
 * @property {String} [exportName]
 * @property {Function} [customizeCell]
 */

/**
 * @param {ExportPluginOptions} [options = {}]
 *
 * @returns {import("../datagrid").Plugin}
 */
export function exportPlugin(options = {}) {
  // Unlike most triggers, the export button is not contained within
  // the DataGrid component, it is global to the page.
  const $exportButton = document.querySelector(".js-datagrid-export");
  if (!$exportButton) {
    console.warn("Export button could not be found");
  }

  const exportName = options.exportName || $exportButton.getAttribute("data-export-name");
  const customizeCell = options.customizeCell;

  return {
    id: "export",

    onDataGridCreated() {
      $exportButton.addEventListener("click", () => exportGridToExcel(this, exportName, customizeCell));
    },
  };
}
